export const createUrlFromTld = tld => {
  const tlds = ['.com', '.de', '.fr', '.co.uk', '.es', '.eu'];

  // Extract the base URL
  const origin =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : '';

  if (origin.includes('localhost')) {
    return `${origin}?domain=www.savagex${tld}`;
  }

  const currentTld = tlds.find(t => origin.includes(t));

  if (currentTld) {
    return origin?.replace(currentTld, tld);
  } else {
    return origin;
  }
};
